import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { defaultPortalBase } from '../contexts/MarketContext';

export default function ProtectedRoute({ children, allowedRole, requirePortal, allowMultiPortal }) {
  const { currentUser, userRoles, userPortals, hasPortal, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Portal-gated staff routes (/staff, /es, /pad). Admins pass everywhere.
  // `allowMultiPortal` lets any user with 2+ portals in (used by /staff, which
  // also hosts the combined "All Tours" roll-up).
  if (requirePortal) {
    const ok = isAdmin
      || hasPortal(requirePortal)
      || (allowMultiPortal && (userPortals || []).length >= 2);
    if (!ok) {
      const home = defaultPortalBase(userPortals);
      // Avoid redirecting onto the same path we just denied.
      return <Navigate to={home === location.pathname ? '/login' : home} replace />;
    }
    return children;
  }

  if (allowedRole) {
    const allowed = Array.isArray(allowedRole) ? allowedRole : [allowedRole];
    // Admins are superusers for the staff-side portals.
    if (isAdmin && allowed.some((r) => r === 'staff' || r === 'staff_es' || r === 'staff_pad')) return children;
    if (!allowed.some((r) => userRoles.includes(r))) return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
